export default "__VITE_ASSET__HH5Mdhq7__"